import moment from 'moment';
import * as actionTypes from 'actions/actionTypes';
import queryStringParser from 'utils/queryStringParser';
import { getCachedQueryString } from 'utils/localRepository';
import sessionRepository from 'utils/sessionRepository';
import { getRedirectUrlSS } from 'utils/helpers';
import { SMART_ID_ERROR } from 'consts';
import { TAX_AUTHORITY_CONSENTS_CLICKED, TAX_AUTHORITY_CONSENTS_URL } from 'consts/loan/localStorage';

let queryString = location.search;

if (COUNTRY === 'FI' || COUNTRY === 'LT' || COUNTRY === 'EE') {
  queryString = getCachedQueryString() || queryString;
}

const queryParameters = queryStringParser.parseAndMakeKeysLowerCase(queryString);

let tupasRejected = false;
if (COUNTRY === 'FI') {
  tupasRejected = location.hash.includes('!tupas/reject') || location.hash.includes('!tupas/disabled');
}

if (COUNTRY === 'EE') {
  tupasRejected = location.hash.includes('!ipizza/error');
}

let channel = queryParameters.channel;

if (COUNTRY === 'MX') {
  channel = channel || sessionRepository.getItem('mx_channel');
}

const initialState = {
  tupasRejected,
  channel,
  isAuthSessionChecked: true,
  isAuthenticated: false,
  isLoading: false,
  isVerifying: false,
  isPasswordRecoveryScreen: false,
  isRecoveryEmailSent: false,
  isRegConfirmationNeeded: false,
  isRegCompletionNeeded: false,
  isPasswordNeeded: false,
  isBankLoginNeeded: false,
  isPinCodeRequested: false,
  isCustomerBlocked: false,
  isApplyGuarantor: false,
  mainApplicationId: null,
  bankLoginParams: null,
  username: null,
  errorMessage: null,
  challenge: null,
  exception: null,
  firstName: null,
  lastName: null,
  msisdn: null,
  personalCode: null,
  sessCode: null,
  transactionId: null,
  registerData: {
    isLoaded: false,
  },
  isLoginScreen: queryParameters.showlogin === 'true',
  isSignUpGate: queryParameters.signupgate === 'true',
  signUpGateSubmitted: false,
  loginFailCount: 0,
  isRedirectingLegacyCustomer: false,
  redirectURL: null,
  recoveryEmail: '',
  metadata: {},
  registrationStep: 0,
  isSelfServiceImpersonation: false,
  isExpiredPage: false,
  confirmationKey: null,
  impersonationKey: null,
  brokerUrl: null,
  OCMStatus: null,
  isEmailPending: false,
  isJustLogedIn: false,
  shouldShowConsentPage: false,
};

if (INCREASE_APP) {
  initialState.increaseType = queryParameters.increasetype;
}
if (UNIFIED_APP) {
  initialState.appParameters = {
    landingUrl: '/apply',
  };
}

if (COUNTRY === 'MX') {
  initialState.policy = queryParameters.telesales === 'true' ? 'TELESALES' : 'DEFAULT';
}

const getErrorObject = (errorData, defaultMessage) => {
  let errorMessage = defaultMessage;
  let exception = null;
  if (errorData.data && errorData.data.errCode) {
    errorMessage = null;
    exception = errorData.data.errCode;
  } else if (errorData.data && errorData.data.statusCode) {
    errorMessage = null;
    exception = errorData.data.statusCode;
  }
  if (COUNTRY === 'MX') {
    if (errorData.data && errorData.data.params) {
      return {
        errorMessage,
        exception,
        rejectReason: errorData.data.params.rejectReason,
      };
    }
  }
  return {
    errorMessage,
    exception,
  };
};

export default function reducer(state = { ...initialState, isAuthSessionChecked: false }, action) {
  switch (action.type) {
    case actionTypes.RESTORE_SESSION:
    case actionTypes.CHECK_MW_TOKEN: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case actionTypes.PUT_MISSING_ADDITIONAL_CONSENT_SUCCESS: {
      return {
        ...state,
        shouldShowConsentPage: false,
      };
    }

    case actionTypes.GET_CONSENTS: {
      return {
        ...state,
        isLoading: true,
        shouldShowConsentPage: false,
      };
    }

    case actionTypes.GET_CONSENTS_SUCCESS: {
      const shouldShowConsentPage = action.result.data && action.result.data.length < 4;

      return {
        ...state,
        isLoading: false,
        shouldShowConsentPage,
      };
    }

    case actionTypes.GET_CONSENTS_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case actionTypes.SET_MW_TOKEN: {
      return {
        ...state,
        mobileWalletToken: action.data,
      };
    }

    case actionTypes.RESTORE_SESSION_SUCCESS:
    case actionTypes.CHECK_MW_TOKEN_SUCCESS: {
      const {
        customer, authenticationMethod, mobileWalletStatus,
      } = action.result.data;
      const nextState = {
        ...state,
        ...customer,
        authenticationMethod,
        mobileWalletStatus,
        isLoading: false,
        isAuthenticated: true,
        isAuthSessionChecked: true,
        isEmailPending: customer.emailPending !== null,
      };
      if (['PL', 'EE', 'LV', 'ES', 'AU', 'CZ'].includes(COUNTRY)) {
        delete nextState.shouldReportAuthEvent;
      }
      if (MOBILE_WALLET) {
        nextState.isMwTokenChecked = true;
      }
      return nextState;
    }

    case actionTypes.DELETE_SHOULD_REPORT_AUTH_EVENT: {
      const nextState = {
        ...state,
      };
      delete nextState.shouldReportAuthEvent;
      return nextState;
    }

    case actionTypes.RESTORE_SESSION_FAIL: {
      return {
        ...state,
        isLoading: false,
        isAuthSessionChecked: true,
      };
    }

    case actionTypes.CHECK_MW_TOKEN_FAIL: {
      const nextState = {
        ...state,
        isLoading: false,
      };
      if (MOBILE_WALLET) {
        nextState.isMwTokenChecked = true;
      }
      return nextState;
    }

    case actionTypes.GET_REGISTER_DATA: {
      return {
        ...state,
        registerData: {
          isLoaded: false,
        },
      };
    }
    case actionTypes.GET_REGISTER_DATA_SUCCESS: {
      return {
        ...state,
        registerData: {
          ...action.result.data,
          isLoaded: true,
        },
      };
    }
    case actionTypes.GET_REGISTER_DATA_FAIL: {
      return {
        ...state,
        registerData: {
          isLoaded: true,
        },
      };
    }
    case actionTypes.BANK_LOGIN_START: {
      const { data = {} } = action;
      return {
        ...state,
        isLoading: true,
        isBankLoginNeeded: false,
        isBankLoginFailed: false,
        isBankLoginLoading: true,
        bankLoginName: data.bank,
        bankLoginParams: null,
        errorMessage: null,
        exception: null,
      };
    }
    case actionTypes.BANK_LOGIN_START_SUCCESS: {
      const parameters = [];
      Object.keys(action.result.data.parameters).forEach((prop) =>
        parameters.push({ name: prop, value: action.result.data.parameters[prop] }));
      return {
        ...state,
        isBankLoginNeeded: true,
        isLoading: false,
        bankLoginParams: {
          url: action.result.data.url,
          parameters,
        },
      };
    }
    case actionTypes.BANK_LOGIN_START_FAIL: {
      return {
        ...initialState,
        isLoading: false,
        errorMessage: 'banklogin.error.generic',
        isBankLoginFailed: true,
        isBankLoginLoading: false,
        mobileWalletToken: state.mobileWalletToken,
        mobileWalletStatus: state.mobileWalletStatus,
      };
    }
    case actionTypes.MOBILE_ID_START:
    case actionTypes.SMART_ID_START:
    case actionTypes.SMART_ID_STATUS:
    case actionTypes.SIGNUP_START:
    case actionTypes.SIGNUP_CONFIRM:
    case actionTypes.SEND_NEW_PASSWORD:
    case actionTypes.CHANGE_PASSWORD:
    case actionTypes.SIGNUP_COMPLETE:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.MOBILE_ID_START_SUCCESS: {
      let exception = null;
      if (action.result.data && action.result.data.exception && action.result.data.exception.code) {
        exception = action.result.data.exception.code;
      }
      return {
        ...state,
        ...action.result.data,
        isLoading: false,
        exception,
      };
    }
    case actionTypes.MOBILE_ID_START_FAIL: {
      let errorMessage = 'aio.errorCode.mobileid_generic';
      let exception = null;
      if (action.error.data && action.error.data.errCode) {
        errorMessage = null;
        exception = action.error.data.errCode;
      }
      if (action.error.data && action.error.data.exception && action.error.data.exception.code) {
        errorMessage = null;
        exception = action.error.data.exception.code;
      }
      return {
        ...initialState,
        isLoading: false,
        errorMessage,
        exception,
      };
    }
    case actionTypes.MOBILE_ID_VERIFY:
      return {
        ...state,
        isVerifying: true,
        isAuthenticated: false,
        errorMessage: null,
        exception: null,
      };
    case actionTypes.MOBILE_ID_VERIFY_SUCCESS: {
      const auth = action.result.data;
      let exception = null;
      if (auth && auth.exception && auth.exception.code) {
        exception = auth.exception.code;
      }
      return {
        ...state,
        ...auth,
        exception,
        isVerifying: false,
        challenge: null,
        shouldReportAuthEvent: exception === null,
      };
    }
    case actionTypes.MOBILE_ID_VERIFY_FAIL: {
      const error = action.error;
      return {
        ...initialState,
        isVerifying: false,
        errorMessage: `mobileid.error.http.${error.status}`,
      };
    }
    case actionTypes.SMART_ID_START_SUCCESS: {
      const { verificationCode } = action.result.data;
      const nextState = {
        ...state,
        verificationCode,
        isLoading: false,
      };
      return nextState;
    }
    case actionTypes.SMART_ID_START_FAIL: {
      if (action.error.data) {
        const { data: { type } } = action.error;
        return {
          ...state,
          isLoading: false,
          verificationCode: null,
          errorMessage: 'aio.errorCode.smartid_generic',
          errorMessageValues: {
            value: `${SMART_ID_ERROR}.${type}`,
          },
        };
      }
      const errorObj = getErrorObject(action.error, 'signup.error.generic');
      return {
        ...initialState,
        ...errorObj,
        isLoading: false,
        isLoginScreen: state.isLoginScreen,
      };
    }
    case actionTypes.SMART_ID_STATUS_SUCCESS: {
      if (action.result.status === 200) {
        const { principal, registrationToken } = action.result.data;

        if (principal) {
          const { countryCode, ...chosenPrincipalValues } = principal;

          if (COUNTRY === 'LT') {
            sessionRepository.saveItem('authMethod', 'smartId');
            return {
              ...state,
              isLoading: false,
              smartIdPrincipal: chosenPrincipalValues,
              isLoginScreen: false,
              registrationStep: 1,
            };
          }

          return {
            ...state,
            isLoading: false,
            smartIdPrincipal: principal,
            smartIdOtpSendEndpoint: COUNTRY === 'EE' && `${API_HOST}/authentication/user-registration/smart-id/${registrationToken}`,
          };
        }

        const nextState = {
          ...state,
          ...action.result.data.customer,
          isLoading: false,
          isPasswordNeeded: false,
          isAuthenticated: true,
          shouldReportAuthEvent: true,
          isLoginScreen: true,
        };

        if (COUNTRY === 'LT') {
          nextState.registrationStep = 1;
        }

        return nextState;
      }
      return state;
    }
    case actionTypes.SMART_ID_STATUS_FAIL: {
      const { temporaryFailureTimeout, startTime } = action.data;
      const timeSpent = Date.now() - startTime;
      const isTimeout = action.error.code === 'ECONNABORTED';
      const nextState = {
        ...state,
        isLoading: false,
        verificationCode: null,
      };
      if (timeSpent < temporaryFailureTimeout) {
        if (isTimeout) {
          return state;
        }
      }
      if (action.error.data) {
        const { data: { type } } = action.error;
        return {
          ...nextState,
          errorMessage: 'aio.errorCode.smartid_generic',
          errorMessageValues: {
            value: `${SMART_ID_ERROR}.${type}`,
          },
        };
      }
      const errorObj = getErrorObject(action.error, 'signup.error.generic');
      return {
        ...nextState,
        ...errorObj,
      };
    }
    case actionTypes.LOGIN:
    case actionTypes.INIT_PASSWORD_RECOVERY:
    case actionTypes.REGISTER_MX:
    case actionTypes.REGISTER_PL:
    case actionTypes.REGISTER_ES:
    case actionTypes.REGISTER_CZ:
      return {
        ...state,
        isLoading: true,
        errorMessage: null,
      };
    case actionTypes.REGISTER_LT: {
      return {
        ...state,
        isLoading: false,
        errorMessage: null,
        registrationStep: 1,
      };
    }
    case actionTypes.SET_REGISTRATION_STEP: {
      console.log(action);
      return {
        ...state,
        registrationStep: action.data,
      };
    }
    case actionTypes.LOGIN_SUCCESS: {
      const { customer } = action.result.data;
      const nextState = {
        ...state,
        ...customer,
        isLoading: false,
        isPasswordNeeded: false,
        isAuthenticated: true,
        isEmailPending: customer.emailPending !== null,
        isJustLogedIn: true,
      };
      return nextState;
    }
    case actionTypes.REGISTER_MX_SUCCESS:
    case actionTypes.REGISTER_PL_SUCCESS: {
      const nextState = {
        ...state,
        isLoading: false,
        isPasswordNeeded: false,
        isAuthenticated: true,
      };
      if (COUNTRY === 'PL') {
        nextState.shouldReportAuthEvent = true;
      }
      return nextState;
    }

    case actionTypes.LOGIN_FAIL: {
      const errorObj = getErrorObject(action.error, 'signup.error.password');
      const nextState = {
        ...state,
        ...errorObj,
        isLoading: false,
        loginFailCount: state.loginFailCount + 1,
      };

      if (COUNTRY === 'LT') {
        const { exception } = errorObj;
        nextState.isCustomerBlocked = exception === 999;
        nextState.isRedirectingLegacyCustomer = exception === 995;
        if (state.isPasswordNeeded && state.isChangingPassword) {
          nextState.errorMessage = 'otp.password.insert.wrong.password';
        }
      }

      if (COUNTRY === 'ES') {
        const { exception } = errorObj;
        nextState.isForcedPasswordChange = exception === 1004;
      }

      return nextState;
    }

    case actionTypes.UPDATE_CONTACT_INFO_SUCCESS: {
      return {
        ...state,
        isEmailPending: action.data.hasEmailChanged,
      };
    }

    case actionTypes.SAVE_CONTACT_INFO_SUCCESS: {
      if (action.data.emailChanged) {
        return {
          ...state,
          emailPending: action.data.email,
        };
      }
      return state;
    }

    case actionTypes.MIGRATED_USER_PASSWORD_RECOVERY_LT: {
      return {
        ...state,
        isPasswordNeeded: true,
        isChangingPassword: true,
        isForcedPasswordChange: true,
      };
    }

    case actionTypes.INIT_PASSWORD_RECOVERY_SUCCESS: {
      const { result: { data } } = action;

      if (data.hasErrors) {
        let errorMessageValues = {};
        if (COUNTRY === 'AU') {
          if (data.error === 'CUSTOMER_NOT_FOUND_OR_NOT_ENABLED') {
            let registerUrl = `${window.location.origin}${window.location.pathname.replace('password-reset', '')}`;
            if (SELF_SERVICE) {
              registerUrl = '/au/apply/';
            }
            errorMessageValues = { registerUrl };
          }
        }

        return {
          ...state,
          isLoading: false,
          errorMessage: `recovery.error.${action.result.data.error}`,
          errorMessageValues,
        };
      }

      return {
        ...state,
        isLoading: false,
        isRecoveryEmailSent: true,
      };
    }

    case actionTypes.INIT_PASSWORD_RECOVERY_FAIL: {
      return {
        ...state,
        isLoading: false,
        errorMessage: 'signup.error.generic',
      };
    }

    case actionTypes.REGISTER_ES_FAIL:
    case actionTypes.REGISTER_CZ_FAIL:
    case actionTypes.REGISTER_MX_FAIL:
    case actionTypes.REGISTER_PL_FAIL: {
      const errorObj = getErrorObject(action.error, 'signup.error.generic');
      const isExistingUser = errorObj.exception === 1475
        || errorObj.exception === 1463
        || errorObj.exception === 1478
        || errorObj.exception === 1491;
      const nextState = {
        ...state,
        ...errorObj,
        isLoginScreen: COUNTRY === 'MX' && isExistingUser,
        isLoading: false,
      };
      if (COUNTRY === 'CZ') {
        if (errorObj.exception === 1491) {
          nextState.errorMessageValues = {
            url: getRedirectUrlSS(),
          };
        }
      }
      return nextState;
    }

    case actionTypes.SIGNUP_START_SUCCESS: {
      const nextState = {
        ...state,
        ...action.result.data,
        isRegConfirmationNeeded: true,
        isLoading: false,
      };
      if (COUNTRY === 'LT') {
        nextState.customer = {
          ...nextState.customer,
          ssn: action.result.config.ssn,
        };
        nextState.isRegConfirmationNeeded = false;
        nextState.isRegConfirmationRequested = true;
        nextState.isPinCodeRequested = true;
      }
      return nextState;
    }

    case actionTypes.SIGNUP_START_FAIL: {
      const errorObject = getErrorObject(action.error, 'signup.error.generic');
      const { exception } = errorObject;

      const nextState = {
        ...state,
        ...errorObject,
        isLoading: false,
      };

      if (COUNTRY === 'LT') {
        nextState.isRedirectingLegacyCustomer = [1456, 1483].includes(exception);
        nextState.isLoginScreen = [1414, 1474, 1401].includes(exception);
        if (exception === 1499) {
          nextState.registrationStep = 0;
        }
      } else if (COUNTRY === 'LV' && [1401, 1474].includes(exception)) {
        nextState.isLoginScreen = true;
      }

      return nextState;
    }

    case actionTypes.SIGNUP_CONFIRM_SUCCESS: {
      let nextState = {
        ...state,
        isLoading: false,
        isRegConfirmationNeeded: false,
        isRegCompletionNeeded: COUNTRY === 'AU',
        isAuthenticated: COUNTRY !== 'AU',
      };
      if (['EE', 'LV'].includes(COUNTRY)) {
        nextState.shouldReportAuthEvent = true;
      }

      if (COUNTRY === 'LT') {
        nextState.shouldTriggerCPL = true;
        nextState.registrationStep = 0;
        const { result: { data } } = action;
        nextState = { ...nextState, ...data };
      }
      return nextState;
    }

    case actionTypes.REGISTER_ES_SUCCESS:
    case actionTypes.REGISTER_CZ_SUCCESS: {
      const nextState = {
        ...state,
        isLoading: false,
        isAuthenticated: true,
        shouldReportAuthEvent: true,
      };
      return nextState;
    }

    case actionTypes.SIGNUP_COMPLETE_SUCCESS: {
      const nextState = {
        ...state,
        isLoading: false,
        isRegCompletionNeeded: false,
        isAuthenticated: true,
      };
      if (COUNTRY === 'AU') {
        nextState.shouldReportAuthEvent = true;
      }
      return nextState;
    }

    case actionTypes.SIGNUP_COMPLETE_FAIL: {
      const { errorMessage, exception } = getErrorObject(action.error, 'signup.error.generic');
      return {
        ...state,
        errorMessage,
        exception,
        isLoading: false,
        isRegCompletionNeeded: !(exception === 1490 || exception === 1491 || exception === 1492),
        isLoginScreen: exception === 1491 || exception === 1492,
      };
    }

    case actionTypes.SIGNUP_CONFIRM_FAIL: {
      const errCode = action.error.data ? action.error.data.errCode : null;
      let errorMessage = 'signup.error.generic';
      let exception = null;
      if (errCode) {
        errorMessage = null;
        exception = errCode;
      }
      return {
        ...state,
        isLoading: false,
        errorMessage,
        exception,
        isRegConfirmationNeeded: COUNTRY !== 'LT',
      };
    }

    case actionTypes.GET_OTP_START_SUCCESS: {
      const nextState = {
        ...state,
        isPinCodeRequested: true,
      };
      if (state.smartIdPrincipal) {
        nextState.smartIdOtpConfirmEndpoint = action.result.headers.location;
      }
      return nextState;
    }

    case actionTypes.LOGOUT_SUCCESS: {
      const nextState = { ...initialState };

      if (action.data && action.data.redirectURL) {
        nextState.redirectURL = action.data.redirectURL;
      }

      if (COUNTRY === 'EE') {
        localStorage.removeItem(TAX_AUTHORITY_CONSENTS_CLICKED);
        localStorage.removeItem(TAX_AUTHORITY_CONSENTS_URL);
      }

      return nextState;
    }

    case actionTypes.ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.message,
      };

    case actionTypes.CUSTOMER_REDIRECT:
      return {
        ...state,
        isRedirecting: true,
      };
    case actionTypes.GET_NEW_PASSWORD:
      return {
        ...state,
        isNewPasswordRequest: true,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.CANCEL_GET_NEW_PASSWORD:
      return {
        ...state,
        isNewPasswordRequest: false,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.CANCEL_TEMPORARY_PASSWORD_LOGIN:
      return {
        ...state,
        isNewPasswordRequest: true,
        isChangingPassword: true,
        isPasswordNeeded: false,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.SEND_NEW_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isChangingPassword: true,
        isPasswordNeeded: true,
        isNewPasswordRequest: false,
      };

    case actionTypes.SEND_NEW_PASSWORD_FAIL: {
      let errorMessage;
      let exception;
      let errorCode;
      if (action.error.data && action.error.data.errCode) {
        errorMessage = null;
        exception = action.error.data.errCode;
      } else if (action.error.data && action.error.status) {
        errorCode = action.error.status;
      }
      return {
        ...state,
        isLoading: false,
        errorMessage,
        exception,
        errorCode,
      };
    }

    case actionTypes.CHANGE_PASSWORD_SUCCESS: {
      const nextState = {
        ...state,
        isLoading: false,
      };
      if (state.isForcedPasswordChange) {
        nextState.isForcedPasswordChange = false;
        if (COUNTRY === 'LT') {
          nextState.isChangingPassword = false;
        }
      } else {
        const showsPasswordChangedFeedback = (COUNTRY === 'ES' || COUNTRY === 'PL');
        nextState.showsPasswordChangedFeedback = showsPasswordChangedFeedback;
        nextState.isChangingPassword = showsPasswordChangedFeedback;
      }
      return nextState;
    }

    case actionTypes.CHANGE_PASSWORD_COMPLETED:
      return {
        ...state,
        isLoading: false,
        showsPasswordChangedFeedback: false,
        isChangingPassword: false,
      };

    case actionTypes.CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        isLoading: false,
        exception: action.error.data.errCode,
      };

    case actionTypes.TOGGLE_AUTH_METHOD:
      return {
        ...state,
        isLoginScreen: action.data,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.TOGGLE_RECOVERY_PASSWORD:
      return {
        ...state,
        isPasswordRecoveryScreen: !state.isPasswordRecoveryScreen,
        isRecoveryEmailSent: false,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.PASSWORD_LINK_RECOVERY_NAVIGATE_BACK: {
      const newState = {
        ...state,
        isRecoveryEmailSent: false,
      };
      if (COUNTRY === 'MX') {
        newState.errorMessage = null;
      }
      return newState;
    }
    case actionTypes.CANCEL_PASSWORD_RECOVERY:
      return {
        ...state,
        isPasswordRecoveryScreen: false,
        isChangingPassword: false,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.SAVE_SIGN_UP_DATA:
      return {
        ...state,
        isSignUpGate: false,
        signUpGateSubmitted: true,
      };

    case actionTypes.CLEAR_SIGN_UP_GATE:
      return {
        ...state,
        isSignUpGate: false,
      };

    case actionTypes.FINISH_SIGNUP_START: {
      return {
        ...state,
        isRegConfirmationRequested: false,
        isRegConfirmationNeeded: true,
      };
    }

    case actionTypes.PUT_CUSTOMER_EMAIL:
    case actionTypes.IMPERSONATION:
    case actionTypes.GET_BANKS_LIST_LT: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case actionTypes.GET_BANKS_LIST_LT_SUCCESS: {
      if (action.result.data) {
        return {
          ...state,
          isLoading: false,
          banksList: action.result.data,
        };
      }
      const banksList = action.result[0].data;
      const paymentData = action.result[1].data.paymentData;
      const result = banksList.map((bank) => {
        const data = paymentData.find((details) => details.name === bank.value);
        return {
          ...bank,
          id: data.id,
          md5: data.md5,
          paymentLink: data.paymentLink,
          recipient: data.recipient,
        };
      });
      return {
        ...state,
        isLoading: false,
        banksList: result,
      };
    }

    case actionTypes.PUT_CUSTOMER_EMAIL_SUCCESS:
    case actionTypes.PUT_CUSTOMER_EMAIL_FAIL:
    case actionTypes.IMPERSONATION_FAIL:
    case actionTypes.GET_BANKS_LIST_LT_FAIL: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case actionTypes.GET_LOCAL_TIME_SUCCESS: {
      return {
        ...state,
        localTimeMoment: moment(action.result.data.time, 'HH:mm'),
      };
    }

    case actionTypes.GET_LOCAL_TIME_FAIL: {
      return {
        ...state,
        localTimeMoment: moment.startOf('minute'),
      };
    }

    case actionTypes.IMPERSONATION_SUCCESS: {
      const {
        customer, authenticationMethod,
      } = action.result.data;
      return {
        ...state,
        ...customer,
        authenticationMethod,
        isLoading: false,
        isPasswordNeeded: false,
        isAuthenticated: true,
      };
    }

    case actionTypes.OCM_STATUS_SUCCESS: {
      const { status } = action.result.data;
      return {
        ...state,
        OCMStatus: status,
      };
    }

    case actionTypes.SET_APPLY_GUARANTOR: {
      const {
        mainApplicationId,
      } = action.data;
      return {
        ...state,
        isApplyGuarantor: true,
        mainApplicationId,
      };
    }

    case actionTypes.SET_CPL_TRIGGERED: {
      const nextState = {
        ...state,
      };
      delete nextState.shouldTriggerCPL;
      return nextState;
    }

    case actionTypes.START_ONE_CENT_IDENTIFICATION_SUCCESS:
      return {
        ...state,
        bankAccountVerified: false,
      };

    case actionTypes.MAKE_USER_CHANGING_PASSWORD:
      return {
        ...state,
        isChangingPassword: true,
      };

    case actionTypes.RESET_BANK_LOGIN:
      return {
        ...state,
        isBankLoginNeeded: false,
        bankLoginParams: null,
      };

    case actionTypes.SET_LANDING_URL:
      return {
        ...state,
        appParameters: {
          ...state.appParameters,
          landingUrl: action.data,
        },
      };

    case actionTypes.PUT_CUSTOMER:
      return {
        ...state,
        errorMessage: null,
        exception: null,
      };

    case actionTypes.PUT_CUSTOMER_FAIL:
      return {
        ...state,
        ...getErrorObject(action.error, 'signup.error.generic'),
      };

    case actionTypes.SMART_ID_APP_CONFIRM_START:
      return {
        ...state,
        isLoading: true,
      };

    case actionTypes.SMART_ID_APP_CONFIRM_SUCCESS: {
      const { verificationCode } = action.result.data;
      const nextState = {
        ...state,
        confirmationVerificationCode: verificationCode,
      };
      return nextState;
    }

    case actionTypes.SMART_ID_APP_CONFIRM_FAIL:
      return {
        ...state,
        isLoading: false,
      };

    case actionTypes.SMART_ID_APP_CONFIRM_STATUS_FAIL:
      return {
        ...state,
        confirmationVerificationCode: null,
        isLoading: false,
      };

    case actionTypes.ONE_CENT_PAYMENT_STATUS_SUCCESS:
      return {
        ...state,
        identificationState: action.result.data.accountStatus,
        oneCentStatus: action.result.data.applicationStatus,
        isLoading: false,
        confirmationVerificationCode: null,
      };

    case actionTypes.SET_BANK_PAYMENT_BUTTON_CLICKED:
      return {
        ...state,
        bankPaymentBtnClicked: action.data,
      };

    case actionTypes.SHOW_I_PAID_BUTTON:
      return {
        ...state,
        isPaymentConfirmationButtonVisible: action.data,
      };

    case actionTypes.SET_SELF_SERVICE_IMPERSONATION:
      return {
        ...state,
        isSelfServiceImpersonation: true,
      };

    case actionTypes.SET_EXPIRED_PAGE:
      return {
        ...state,
        isExpiredPage: true,
      };

    case actionTypes.SET_CONFIRMATION_KEY:
      return {
        ...state,
        confirmationKey: action.data,
      };

    case actionTypes.SET_IMPERSONATION_KEY:
      return {
        ...state,
        impersonationKey: action.data,
      };

    case actionTypes.SET_BROKER_URL:
      return {
        ...state,
        brokerUrl: action.data,
      };

    case actionTypes.GET_REIDENTIFY_OTP_START: {
      const nextState = {
        ...state,
        isPinCodeRequested: true,
      };
      if (state.smartIdPrincipal) {
        nextState.smartIdOtpConfirmEndpoint = action.result.headers.location;
      }
      return nextState;
    }

    case actionTypes.RESET_LOGIN_FLAG: {
      const nextState = {
        ...state,
        isJustLogedIn: false,
      };
      return nextState;
    }

    default:
      return state;
  }
}
